module.exports = __webpack_public_path__ + "633aeabc0feb2aee75c3b754c0d05014.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-right-12.png
// module id = 2691
// module chunks = 0